/*=========================================================================================
  File Name: moduleStockMutations.js
  Description: Supplier Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  SET_SUPPLIERS(state, payload) {
    state.suppliers = payload;
  },
};
